export const statusMapper = {
  issue: 'Issue',
  good_job: 'Good job',
  comment: 'Comment',
};